export const getBrand = () => {
  if (window._THULEDATA !== null) {
    return window._THULEDATA.SitecoreSiteName;
  } else if (window._EXTRANETDATA !== null) {
    return window._EXTRANETDATA.SitecoreSiteName;
  }

  return '';
};
